export const DEFAULT_WEBSITE_ONBOARDING_QUESTIONS = [
  {
    title: "Website goals",
    description: "Help us understand what your website needs to achieve.",
    questions: [
      {
        id: "websitePurpose",
        label: "What is the main purpose of your website?",
        type: "select",
        options: [
          "Promote my business",
          "Generate leads",
          "Showcase a portfolio",
          "Share information or news",
          "Offer online bookings",
          "Other",
        ],
      },
      {
        id: "businessDescription",
        label: "What does your business do, and who are your customers?",
        type: "textarea",
      },
      {
        id: "websiteType",
        label: "What kind of website are you looking for?",
        type: "select",
        options: [
          "Business or corporate website",
          "Portfolio",
          "Landing page",
          "Blog or publication",
          "Web application",
          "Not sure yet",
        ],
      },
    ],
  },
  {
    title: "Content and launch",
    description: "Tell us what is ready and what support you may need.",
    questions: [
      {
        id: "requiredPages",
        label: "Which pages or features should the website include?",
        type: "textarea",
        placeholder: "For example: Home, About, Services, Contact",
      },
      {
        id: "contentReadiness",
        label: "How ready are your text, images, logo, and brand assets?",
        type: "select",
        options: ["Ready", "Some items are ready", "Not ready yet", "Need help"],
      },
      {
        id: "targetLaunchDate",
        label: "When would you like the website to launch?",
        type: "date",
      },
    ],
  },
  {
    title: "Design and support",
    description: "Share any preferences that will help shape the project.",
    questions: [
      {
        id: "designReferences",
        label: "Are there websites or design styles you would like us to consider?",
        type: "textarea",
      },
      {
        id: "websiteSupportAreas",
        label: "What would you like help with?",
        type: "multi-select",
        options: [
          "Writing website content",
          "Branding and design",
          "Domain and hosting",
          "Search engine optimization",
          "Online bookings",
          "Ongoing maintenance",
          "Other",
        ],
      },
    ],
  },
];

export const parseWebsiteOnboardingQuestions = (value) => {
  if (!value) return DEFAULT_WEBSITE_ONBOARDING_QUESTIONS;
  const questions = typeof value === "string" ? JSON.parse(value) : value;
  if (
    !Array.isArray(questions) ||
    questions.some(
      (section) =>
        !section ||
        typeof section.title !== "string" ||
        !Array.isArray(section.questions),
    )
  ) {
    throw new Error("Website onboarding questions have an invalid format.");
  }
  return questions;
};
